import { forwardRef, type Ref, type SVGProps } from "react";
const IconBuildingOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-9 26v-5h2v5zm9 0h-5v-6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V28H8V4h16z"
    />
    <rect width={4} height={4} x={11} y={13} fill="currentColor" rx={0.5} />
    <rect width={4} height={4} x={17} y={13} fill="currentColor" rx={0.5} />
    <rect width={4} height={4} x={11} y={7} fill="currentColor" rx={0.5} />
    <rect width={4} height={4} x={17} y={7} fill="currentColor" rx={0.5} />
  </svg>
);
const ForwardRef = forwardRef(IconBuildingOutlineSVG);
ForwardRef.displayName = "IconBuildingOutline";
export { ForwardRef as IconBuildingOutline };
